import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type ProgramSummaryResponse = {
  access: {
    allowed: boolean
    reason: 'PROGRAM_NOT_FOUND' | 'PROGRAM_NOT_IN_USER_ORG' | null
  }
  capabilities: {
    hasPredictionCorrections: boolean
  } | null
}

const PROGRAM_SUMMARY_KEY = 'program-summary'

export const useGetProgramSummary = (programId?: string) => {
  return useQuery({
    queryKey: [PROGRAM_SUMMARY_KEY, programId],
    queryFn: async () => {
      const { data } = await apiClient.get<ProgramSummaryResponse>(`/int/v3/programs/${programId}/summary`)

      return data
    },
    enabled: Boolean(programId),
    refetchOnWindowFocus: false,
  })
}
